import { useRef, useState } from "react";
import { useFavorites } from "@/hooks/useFavorites";

interface DetailActionsProps {
  movieId: string;
  movieTitle: string;
}

export default function DetailActions({ movieId, movieTitle }: DetailActionsProps) {
  const { isFavorite, toggleFavorite } = useFavorites();
  const [toast, setToast] = useState("");
  const timer = useRef<number | null>(null);
  const favorited = isFavorite(movieId);

  const showToast = (message: string) => {
    setToast(message);
    if (timer.current) window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => setToast(""), 2200);
  };

  const handleFavorite = () => {
    const added = toggleFavorite(movieId);
    showToast(added ? "已加入收藏，可在右上角收藏夹中查看" : "已取消收藏");
  };

  const handleShare = async () => {
    const url = window.location.href;
    try {
      if (typeof navigator.share === "function") {
        await navigator.share({ title: movieTitle, text: `${movieTitle} - 韩国三级电影`, url });
        return;
      }
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(url);
        showToast("链接已复制到剪贴板");
        return;
      }
      showToast("请手动复制浏览器地址进行分享");
    } catch {
      // 用户取消分享，无需额外处理
    }
  };

  return (
    <>
      <div className="flex flex-wrap items-center gap-3">
        <button
          type="button"
          onClick={handleFavorite}
          className={`flex items-center gap-2 whitespace-nowrap rounded-md px-5 py-2.5 text-sm font-medium transition-colors duration-200 ${
            favorited
              ? "bg-accent-500 text-background-50 hover:bg-accent-600"
              : "bg-primary-500 text-background-50 hover:bg-primary-600"
          }`}
        >
          <i className={favorited ? "ri-bookmark-fill text-base" : "ri-bookmark-line text-base"} aria-hidden="true" />
          {favorited ? "已收藏" : "收藏"}
        </button>
        <button
          type="button"
          onClick={handleShare}
          className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors duration-200 hover:border-primary-300 hover:text-primary-600"
        >
          <i className="ri-share-line text-base" aria-hidden="true" />
          分享
        </button>
      </div>

      {toast ? (
        <div className="fixed bottom-8 left-1/2 z-50 -translate-x-1/2 animate-fade-up rounded-full bg-foreground-950/90 px-5 py-2.5 text-sm font-medium text-background-50">
          {toast}
        </div>
      ) : null}
    </>
  );
}